module.exports = __webpack_public_path__ + "static/img/200316.5fc4004a.png";